import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmptyStateCallGroup = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 436,
	height: 411,
	viewBox: "0 0 436 411",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M207.892 411.005C312.72 411.005 397.701 326.024 397.701 221.196C397.701 116.367 312.72 31.3867 207.892 31.3867C103.063 31.3867 18.0825 116.367 18.0825 221.196C18.0825 326.024 103.063 411.005 207.892 411.005Z",
			fill: "#EBF3FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M116.28 213.497L315.048 226.871",
			stroke: "#002F75",
			strokeWidth: 4.33348,
			strokeMiterlimit: 10,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M244.462 341.107L296.371 323.341",
			stroke: "#002F75",
			strokeWidth: 4.33348,
			strokeMiterlimit: 10,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0_23707_97204",
			style: { maskType: "luminance" },
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 131,
			width: 147,
			height: 148,
			children: /* @__PURE__ */ _jsx("path", {
				d: "M73.424 278.197C113.975 278.197 146.848 245.324 146.848 204.773C146.848 164.222 113.975 131.349 73.424 131.349C32.873 131.349 0 164.222 0 204.773C0 245.324 32.873 278.197 73.424 278.197Z",
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsxs("g", {
			mask: "url(#mask0_23707_97204)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M73.424 278.197C113.975 278.197 146.848 245.324 146.848 204.773C146.848 164.222 113.975 131.349 73.424 131.349C32.873 131.349 0 164.222 0 204.773C0 245.324 32.873 278.197 73.424 278.197Z",
					fill: "#9EC5FF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M74.8608 217.819C91.1109 217.819 104.284 204.646 104.284 188.395C104.284 172.145 91.1109 158.972 74.8608 158.972C58.6108 158.972 45.4375 172.145 45.4375 188.395C45.4375 204.646 58.6108 217.819 74.8608 217.819Z",
					fill: "#6BA6FF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M68.1328 316.59C96.4978 316.59 119.492 293.596 119.492 265.23C119.492 236.865 96.4978 213.871 68.1328 213.871C39.7678 213.871 16.7734 236.865 16.7734 265.23C16.7734 293.596 39.7678 316.59 68.1328 316.59Z",
					fill: "#6BA6FF"
				})
			]
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M188.502 388.635C213.97 388.635 234.616 367.989 234.616 342.521C234.616 317.052 213.97 296.406 188.502 296.406C163.033 296.406 142.387 317.052 142.387 342.521C142.387 367.989 163.033 388.635 188.502 388.635Z",
			fill: "#9EC5FF"
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "mask1_23707_97204",
			style: { maskType: "luminance" },
			maskUnits: "userSpaceOnUse",
			x: 142,
			y: 296,
			width: 93,
			height: 93,
			children: /* @__PURE__ */ _jsx("path", {
				d: "M188.503 388.636C213.972 388.636 234.618 367.99 234.618 342.521C234.618 317.053 213.972 296.406 188.503 296.406C163.035 296.406 142.389 317.053 142.389 342.521C142.389 367.99 163.035 388.636 188.503 388.636Z",
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			mask: "url(#mask1_23707_97204)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M196.772 347.871C202.811 343.958 206.245 336.681 204.914 329.147C203.138 319.09 193.549 312.385 183.503 314.149C173.458 315.913 166.742 325.514 168.505 335.56C169.837 343.094 175.549 348.747 182.557 350.371C175.899 353.186 170.479 358.091 167.034 364.177C163.471 370.473 161.988 377.983 163.343 385.669C164.698 393.343 168.657 399.908 174.159 404.603C181.226 410.631 190.839 413.586 200.709 411.845C218.253 408.75 229.969 392.023 226.873 374.479C224.21 359.376 211.443 348.63 196.749 347.883L196.772 347.871Z",
				fill: "#6BA6FF"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M120.892 290.309C137.019 290.309 150.093 277.235 150.093 261.107C150.093 244.98 137.019 231.906 120.892 231.906C104.764 231.906 91.6904 244.98 91.6904 261.107C91.6904 277.235 104.764 290.309 120.892 290.309Z",
			fill: "#FFC700"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M109.667 262.333L117.598 270.264L134.313 253.549",
			stroke: "white",
			strokeWidth: 5.63003,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M183.758 63.4492L271.479 187.87",
			stroke: "#002F75",
			strokeWidth: 4.33348,
			strokeMiterlimit: 10,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M406.542 167.048L312.08 154.242C293.465 151.719 276.329 164.764 273.806 183.379L261.001 277.84C258.477 296.455 271.522 313.591 290.137 316.114L384.598 328.92C403.213 331.443 420.349 318.398 422.873 299.783L435.678 205.322C438.201 186.707 425.157 169.571 406.542 167.048Z",
			fill: "#9AEDE6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M318.237 241.963C323.002 247.593 328.305 252.849 333.083 257.825C350.534 275.965 369.059 284.831 376.593 283.616C381.522 283.301 386.241 280.731 389.126 276.257L391.404 272.73C392.455 271.094 392.035 268.922 390.446 267.812L372.949 255.524C371.862 254.765 370.449 254.66 369.257 255.244L360.509 259.601C359.995 259.858 359.422 259.94 358.862 259.858C357.519 259.636 354.785 257.989 353.886 257.382C348.408 253.667 337.591 242.722 332.756 236.041C331.448 234.242 330.618 232.911 330.326 231.766C330.198 231.252 330.338 230.493 330.571 230.026L335.045 221.078C335.641 219.887 335.536 218.474 334.776 217.387L322.524 199.866C321.414 198.278 319.241 197.846 317.606 198.897L314.067 201.175C308.729 205.158 307.269 209.83 306.661 215.25C306.521 216.476 306.439 218.228 306.802 220.109C308.46 228.694 312.91 235.702 318.213 241.963H318.237Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "mask2_23707_97204",
			style: { maskType: "luminance" },
			maskUnits: "userSpaceOnUse",
			x: 301,
			y: 60,
			width: 47,
			height: 48,
			children: /* @__PURE__ */ _jsx("path", {
				d: "M324.684 107.31C337.483 107.31 347.858 96.9344 347.858 84.1356C347.858 71.3369 337.483 60.9614 324.684 60.9614C311.885 60.9614 301.51 71.3369 301.51 84.1356C301.51 96.9344 311.885 107.31 324.684 107.31Z",
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsxs("g", {
			mask: "url(#mask2_23707_97204)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M324.684 107.31C337.483 107.31 347.858 96.9344 347.858 84.1356C347.858 71.3369 337.483 60.9614 324.684 60.9614C311.885 60.9614 301.51 71.3369 301.51 84.1356C301.51 96.9344 311.885 107.31 324.684 107.31Z",
					fill: "#9EC5FF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M325.397 88.2825C330.526 88.2825 334.683 84.125 334.683 78.9965C334.683 73.8679 330.526 69.7104 325.397 69.7104C320.269 69.7104 316.111 73.8679 316.111 78.9965C316.111 84.125 320.269 88.2825 325.397 88.2825Z",
					fill: "#6BA6FF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M322.009 119.317C330.962 119.317 338.221 112.058 338.221 103.104C338.221 94.1502 330.962 86.8916 322.009 86.8916C313.055 86.8916 305.796 94.1502 305.796 103.104C305.796 112.058 313.055 119.317 322.009 119.317Z",
					fill: "#6BA6FF"
				})
			]
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M65.1891 44.8196C69.7048 44.8196 73.3655 41.1589 73.3655 36.6432C73.3655 32.1275 69.7048 28.4668 65.1891 28.4668C60.6734 28.4668 57.0127 32.1275 57.0127 36.6432C57.0127 41.1589 60.6734 44.8196 65.1891 44.8196Z",
			fill: "#9EC5FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.1212 329.824C23.6369 329.824 27.2976 326.164 27.2976 321.648C27.2976 317.132 23.6369 313.472 19.1212 313.472C14.6055 313.472 10.9448 317.132 10.9448 321.648C10.9448 326.164 14.6055 329.824 19.1212 329.824Z",
			fill: "#DCEBFE"
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "mask3_23707_97204",
			style: { maskType: "luminance" },
			maskUnits: "userSpaceOnUse",
			x: 125,
			y: 0,
			width: 148,
			height: 147,
			children: /* @__PURE__ */ _jsx("path", {
				d: "M198.838 146.848C239.389 146.848 272.262 113.975 272.262 73.424C272.262 32.873 239.389 0 198.838 0C158.287 0 125.414 32.873 125.414 73.424C125.414 113.975 158.287 146.848 198.838 146.848Z",
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsxs("g", {
			mask: "url(#mask3_23707_97204)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M198.838 146.848C239.389 146.848 272.262 113.975 272.262 73.424C272.262 32.873 239.389 0 198.838 0C158.287 0 125.414 32.873 125.414 73.424C125.414 113.975 158.287 146.848 198.838 146.848Z",
					fill: "#9EC5FF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M198.837 86.413C215.087 86.413 228.26 73.2398 228.26 56.9897C228.26 40.7397 215.087 27.5664 198.837 27.5664C182.587 27.5664 169.414 40.7397 169.414 56.9897C169.414 73.2398 182.587 86.413 198.837 86.413Z",
					fill: "#6BA6FF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M198.836 185.464C227.201 185.464 250.196 162.47 250.196 134.105C250.196 105.74 227.201 82.7456 198.836 82.7456C170.471 82.7456 147.477 105.74 147.477 134.105C147.477 162.47 170.471 185.464 198.836 185.464Z",
					fill: "#6BA6FF"
				})
			]
		})
	]
});
export default SvgEmptyStateCallGroup;
